import { EducationLevelRepository } from "../repositories/EducationLevel.repository";

export const EducationLevelService = {
    getEducationLevels,
}

async function getEducationLevels(){
    const res = await EducationLevelRepository.getEducationLevels();
    return res;
}